import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from './routes';
import LoginPage from '../pages/auth/login';
import NotFound from '../pages/not-found';
import { PrivateRoute, PublicRoute } from './guards';
import SignupPage from '../pages/auth/sign-up';
import VerifyEmailPage from '../pages/auth/verify-email';
import ForgotPasswordPage from '../pages/auth/forgot-password';
import ResetPasswordPage from '../pages/auth/reset-password';
import CheckEmailPage from '../pages/auth/CheckEmailPage';
import GmailCallbackPage from '../pages/auth/GmailCallbackPage';
import PodcastSearchPage from '../pages/dashboard/podcast-search';
import PodcastDetailsPage from '../pages/dashboard/podcast-details';
import CreditsPage from '../pages/dashboard/CreditsPage';
import SettingsPage from '../pages/dashboard/settings';
import HomePage from '../pages/home/home-page';
import TermsPage from '../pages/legal/terms-page';
import PrivacyPage from '../pages/legal/privacy-page';
import ContactPage from '../pages/contact/contact-page';
import OutreachCampaignsPage from '../pages/dashboard/outreach-campaigns';
import CampaignBoardPage from '../pages/dashboard/campaign-board';
import PricingPage from '../pages/dashboard/pricing-page';
import PaymentSuccessPage from '../pages/dashboard/payment-success-page';

export default function AppRouter({ isAuthenticated }: { isAuthenticated: boolean }) {
  // Check if we are on the 'app' subdomain
  const isAppSubdomain = window.location.hostname.startsWith('app.');

  const routeComponents = [ 
    {
      ...ROUTES.HOME,
      element: isAppSubdomain ? <Navigate to={ROUTES.LOGIN.path} replace /> : <HomePage />
    },
    {
      ...ROUTES.LOGIN,
      element: <PublicRoute isAuthenticated={isAuthenticated}><LoginPage /></PublicRoute>
    },
    {
      ...ROUTES.SIGNUP,
      element: <SignupPage />
    },
    {
      ...ROUTES.VERIFY_EMAIL,
      element: <VerifyEmailPage />
    },
    {
      ...ROUTES.FORGOT_PASSWORD,
      element: <ForgotPasswordPage />
    },
    {
      ...ROUTES.RESET_PASSWORD,
      element: <ResetPasswordPage />
    },
    {
      ...ROUTES.CHECK_EMAIL,
      element: <CheckEmailPage />
    },
    {
      ...ROUTES.GMAIL_CALLBACK,
      element: <PrivateRoute isAuthenticated={isAuthenticated}><GmailCallbackPage /></PrivateRoute>
    },
    {
      ...ROUTES.DASHBOARD,
      element: <Navigate to={ROUTES.PODCAST_SEARCH.path} replace />
    },
    {
        ...ROUTES.PODCAST_SEARCH,
        element: <PrivateRoute isAuthenticated={isAuthenticated}><PodcastSearchPage /></PrivateRoute>
    },
    {
        ...ROUTES.PODCAST_DETAILS,
        element: <PrivateRoute isAuthenticated={isAuthenticated}><PodcastDetailsPage /></PrivateRoute>
    },
    {
        ...ROUTES.SETTINGS,
        element: <PrivateRoute isAuthenticated={isAuthenticated}><SettingsPage /></PrivateRoute>
    },
    {
        ...ROUTES.CREDITS,
        element: <PrivateRoute isAuthenticated={isAuthenticated}><CreditsPage /></PrivateRoute>
    },
    {
        ...ROUTES.OUTREACH,
        element: <PrivateRoute isAuthenticated={isAuthenticated}><OutreachCampaignsPage /></PrivateRoute>
    },
    {
        ...ROUTES.OUTREACH_CAMPAIGN,
        element: <PrivateRoute isAuthenticated={isAuthenticated}><CampaignBoardPage /></PrivateRoute>
    },
    {
        ...ROUTES.PRICING,
        element: <PrivateRoute isAuthenticated={isAuthenticated}><PricingPage /></PrivateRoute>
    },
    {
        ...ROUTES.PAYMENT_SUCCESS,
        element: <PaymentSuccessPage />
    },
    {
      ...ROUTES.TERMS,
      element: <TermsPage />
    },
    {
      ...ROUTES.PRIVACY,
      element: <PrivacyPage />
    },
    {
      ...ROUTES.CONTACT,
      element: <ContactPage />
    },
    {
      ...ROUTES.NOT_FOUND,
      element: <NotFound />
    }
  ];


  return (
    <BrowserRouter>
      <Routes>
        {routeComponents.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
      </Routes>
    </BrowserRouter>
  );
}